import React from 'react';
import { ArrowLeft, Trash2, Tag, ArrowRight } from 'lucide-react';

const CART_ITEMS = [
  { name: 'Classic Cotton Kurta', designer: 'Studio Name', size: 'M', color: 'Black', qty: 1, price: 2999, image: null },
  { name: 'Silk Embroidered Saree', designer: 'Studio Name', size: 'Free Size', color: 'Red', qty: 2, price: 8999, image: null },
];

const IMG_PLACEHOLDER = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 80 100'%3E%3Crect fill='%23f1f5f9' width='80' height='100'/%3E%3Ctext fill='%2394a3b8' font-family='system-ui' font-size='8' text-anchor='middle' x='40' y='50'%3EProduct%3C/text%3E%3C/svg%3E";

export default function CartPreview({ attributes = {} }) {
  const subtotal = CART_ITEMS.reduce((s, i) => s + i.price * i.qty, 0);
  return (
    <div style={{ padding: '24px', fontFamily: 'Inter, system-ui, sans-serif' }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px' }}>
        <button style={{
          display: 'flex', alignItems: 'center', gap: '6px', background: 'none',
          border: 'none', color: '#6b7280', fontSize: '13px', cursor: 'default',
        }}>
          <ArrowLeft size={16} /> Continue Shopping
        </button>
        <h1 style={{ fontSize: '24px', fontWeight: 600, color: '#111827' }}>Shopping Cart</h1>
        <span style={{
          fontSize: '12px', color: '#6b7280', background: '#f3f4f6',
          padding: '4px 12px', borderRadius: '12px',
        }}>
          {CART_ITEMS.reduce((s, i) => s + i.qty, 0)} items
        </span>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '24px' }}>
        {/* Items */}
        <div>
          {CART_ITEMS.map((item, i) => (
            <div key={i} style={{
              display: 'flex', gap: '16px', padding: '16px',
              borderBottom: '1px solid #f3f4f6', alignItems: 'center',
            }}>
              <div style={{
                width: '80px', height: '100px', borderRadius: '8px', overflow: 'hidden',
                background: '#f8fafc', flexShrink: 0,
              }}>
                <img src={IMG_PLACEHOLDER} alt={item.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
              <div style={{ flex: 1 }}>
                <p style={{ fontSize: '14px', fontWeight: 500, color: '#111827' }}>{item.name}</p>
                <p style={{ fontSize: '11px', color: '#9ca3af', marginTop: '2px' }}>by {item.designer}</p>
                <p style={{ fontSize: '11px', color: '#6b7280', marginTop: '4px' }}>
                  Size: {item.size} {'\u00B7'} Color: {item.color}
                </p>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '8px' }}>
                  <div style={{
                    display: 'flex', border: '1px solid #e5e7eb', borderRadius: '6px',
                  }}>
                    <span style={{ padding: '4px 10px', fontSize: '14px', color: '#6b7280', cursor: 'default' }}>{'\u2212'}</span>
                    <span style={{ padding: '4px 12px', fontSize: '13px', fontWeight: 600, color: '#111827', borderLeft: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb' }}>{item.qty}</span>
                    <span style={{ padding: '4px 10px', fontSize: '14px', color: '#6b7280', cursor: 'default' }}>+</span>
                  </div>
                </div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <p style={{ fontSize: '15px', fontWeight: 600, color: '#111827' }}>{'\u20B9'}{(item.price * item.qty).toLocaleString()}</p>
                <button style={{
                  marginTop: '8px', background: 'none', border: 'none',
                  color: '#ef4444', cursor: 'default', padding: '4px',
                }}>
                  <Trash2 size={14} />
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Summary */}
        <div style={{
          padding: '20px', background: '#f9fafb', borderRadius: '12px',
          border: '1px solid #f0f0f0', height: 'fit-content',
        }}>
          {/* Coupon */}
          <div style={{ marginBottom: '16px' }}>
            <label style={{ fontSize: '12px', fontWeight: 500, color: '#374151', display: 'block', marginBottom: '6px' }}>Coupon Code</label>
            <div style={{ display: 'flex', gap: '8px' }}>
              <div style={{
                flex: 1, padding: '8px 10px', borderRadius: '6px', border: '1px solid #e5e7eb',
                background: '#fff', fontSize: '12px', color: '#9ca3af',
              }}>SAVE10</div>
              <button style={{
                padding: '8px 12px', borderRadius: '6px', border: 'none',
                background: '#111827', color: '#fff', fontSize: '11px', fontWeight: 600, cursor: 'default',
                display: 'flex', alignItems: 'center', gap: '4px',
              }}>
                <Tag size={12} /> Apply
              </button>
            </div>
          </div>

          {/* Price breakdown */}
          <div style={{ borderTop: '1px solid #e5e7eb', paddingTop: '12px' }}>
            {[
              { label: 'Subtotal', value: '\u20B9' + subtotal.toLocaleString() },
              { label: 'Shipping', value: 'Free', color: '#059669' },
              { label: 'Tax', value: '\u20B90' },
            ].map(({ label, value, color }) => (
              <div key={label} style={{
                display: 'flex', justifyContent: 'space-between', padding: '6px 0',
                fontSize: '13px',
              }}>
                <span style={{ color: '#6b7280' }}>{label}</span>
                <span style={{ color: color || '#374151', fontWeight: 500 }}>{value}</span>
              </div>
            ))}
            <div style={{
              display: 'flex', justifyContent: 'space-between', padding: '12px 0',
              borderTop: '1px solid #e5e7eb', marginTop: '8px',
            }}>
              <span style={{ fontSize: '15px', fontWeight: 600, color: '#111827' }}>Total</span>
              <span style={{ fontSize: '18px', fontWeight: 700, color: '#111827' }}>{'\u20B9'}{subtotal.toLocaleString()}</span>
            </div>
          </div>

          <button style={{
            width: '100%', padding: '12px', borderRadius: '8px', border: 'none',
            background: '#111827', color: '#fff', fontSize: '14px', fontWeight: 600,
            cursor: 'default', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
          }}>
            Proceed to Checkout <ArrowRight size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
